$('details').on('click', function(){
  $(this).siblings('details').removeAttr('open')
})
